<mat-dialog-content class="mat-typography">
  <h2>Corrective Details - #{{item}}</h2>
  <mat-card>
    @if (pestInformation && pestInformation.data) {
    <div class="history-table-scroll-container mat-elevation-z1">
      <mat-table [dataSource]="pestInformation.data.tableRows" multiTemplateDataRows class="w-100">
        @for (column of pestInformation.data.tableDefinitions; track column.columnDef) {
        <ng-container [matColumnDef]="column.columnDef">
          <mat-header-cell *matHeaderCellDef class="d-flex align-items-center px-3 fw-bold">{{ column.header }}</mat-header-cell>
          <mat-cell *matCellDef="let row; let i = dataIndex" class="d-flex align-items-center px-3 text-break">
            {{ row[column.columnDef] }}
          </mat-cell>
        </ng-container>
        }
        <mat-header-row *matHeaderRowDef="tableDisplayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: tableDisplayedColumns;" let dataIndex="dataIndex"></mat-row>
      </mat-table>
    </div>

    }
  </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>